import { render, staticRenderFns } from "./ModuleSchemeSlotDetails.vue?vue&type=template&id=2414f227&scoped=true"
import script from "./ModuleSchemeSlotDetails.vue?vue&type=script&lang=js"
export * from "./ModuleSchemeSlotDetails.vue?vue&type=script&lang=js"
import style0 from "./ModuleSchemeSlotDetails.vue?vue&type=style&index=0&id=2414f227&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414f227",
  null
  
)

export default component.exports